import { STATUS_TONES, statusTone } from '../../../data/patientStatuses.js'

/* patient.status now, as a pill in the status's own tone — shared by แท็บรีวิว / รอโทร
 * (api 678 patient_status) and ผลการโทร's log (api 680 patient_status). */
export default function PatientStatus({ status }) {
  if (!status) return <span className="text-slate-300">—</span>
  const t = STATUS_TONES[statusTone(status)] || STATUS_TONES.none
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-1.5 py-0.5 text-[10.5px] ring-1 ${t.pill}`}>
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${t.dot}`} />{status}
    </span>
  )
}
